import React from 'react';
import { Button } from 'antd';
import { FacebookFilled } from "@ant-design/icons";
import { InstagramFilled } from "@ant-design/icons";

const More = () => {
    return(
        <div className='more'>
            <div className='moreBg'></div>
            <div>
                <Button href='http://liceum.kopernik-leszno.pl/' className='moreBtn' size="large" type="primary">Zobacz więcej na naszej stronie</Button>
                <div className='social'>
                    <Button target='_blank' href='https://www.facebook.com/IILOLeszno/' className='socialBtn' type="primary" shape="circle" icon={<FacebookFilled />} />
                    <Button target='_blank' href='https://www.instagram.com/kopernik.leszno/' className='socialBtn' type="primary" shape="circle" icon={<InstagramFilled />} />
                </div>
                <h4 className='moreInfo'>II Liceum Ogólnokształcące im. Mikołaja Kopernika z Oddziałami Dwujęzycznymi i Międzynarodowymi w Lesznie</h4>
            </div>
        </div>
    )
}
export default More;